// script pro rozhodnutí zda custom select zobrazit nahoře nebo klasicky dole
function customSelectAbove() {
  $('.custom-select .select-selected').each(function () {
    // Determine whether bottom of menu will be below window at current scroll position
    if (
      $(this).offset().top + 200 >
      $(window).innerHeight() + $(window).scrollTop()
    ) {
      $(this).closest('.custom-select').addClass('custom-select--above');
    } else {
      $(this).closest('.custom-select').removeClass('custom-select--above');
    }
  });
}
